export const NewTumRegisterEndpoint = {
  GET_NEW_TUM_REGISTER: 'new-tum-register/search',
  GET_COUNT_STATUS_NEW_TUM_REGISTER: 'new-tum-register/count-status',
  NEW_TUM_REGISTER: 'new-tum-register',
  APPROVE_TUM: 'new-tum-register/approve',
  APPROVE_MANY_TUM: 'new-tum-register/approve-many',
    //check-email-in-ueh-api
  //check-email-in-system
  CHECK_EMAIL_IN_UEH_API: 'new-tum-register/check-email-in-ueh-api',
  CHECK_EMAIL_IN_SYSTEM: 'new-tum-register/check-email-in-system',
}
